"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformFaqMarkdownToFaq = void 0;
var marked_1 = require("marked");
var xmldom_1 = require("@xmldom/xmldom");
exports.transformFaqMarkdownToFaq = function (markdown) {
    var html = marked_1.marked.parse(markdown);
    var faqs = [];
    if (!html)
        return faqs;
    var dom = new xmldom_1.DOMParser().parseFromString("<div>" + html + "</div>", "text/html");
    var nodes = dom.childNodes[0].childNodes;
    var elements = Array.from(nodes).filter(function (it) { return it.tagName; });
    for (var _i = 0, elements_1 = elements; _i < elements_1.length; _i++) {
        var element = elements_1[_i];
        if (element.tagName.toLowerCase() == 'h1' || element.tagName.toLowerCase() == 'h2' || element.tagName.toLowerCase() == 'h3') {
            faqs.push({ question: (new xmldom_1.XMLSerializer()).serializeToString(element), answer: '', date: '' });
        }
        else if (element.tagName) {
            if (faqs[faqs.length - 1]) {
                faqs[faqs.length - 1].answer += (new xmldom_1.XMLSerializer()).serializeToString(element);
            }
        }
    }
    return faqs;
};
